import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

export const EnterRegistrationStyle = styled.div`
  background: ${theme.primaryColours.white.main};
  border-radius: ${theme.grid.spacing.xs}px;
  padding: ${theme.grid.spacing.base}px;
  margin: ${theme.grid.spacing.s}px 0 0;
  max-width: 454px;
  .enter-reg-heading {
    margin-top: 0;
  }
  .enter-reg-wrapper {
    display: flex;
    flex-direction: column;
    margin: ${theme.grid.spacing.s}px 0 0;
    input {
      width: 100%;
      font-family: 'uknumberplate', sans-serif !important;
      text-transform: uppercase !important;
      font-weight: normal !important;
      font-size: 24px !important;
      &::placeholder {
        font-family: 'uknumberplate', sans-serif !important;
        font-weight: 400 !important;
        font-size: 24px !important;
        line-height: 18px !important;
        color: #545a5c !important;
      }
    }
    .error-message {
      max-width: 372px;
    }
    .button-tooltip-container {
      display: flex;
      align-items: baseline;
      .reg-button {
        padding: ${theme.grid.spacing.s}px;
        .icon__loading {
          svg {
            position: relative;
            top: 24px;
            height: 18px;
          }
        }
      }
    }
  }
  .reg-tool-tip {
    margin-left: ${theme.grid.spacing.s}px;
    top: 6px;
  }
  @media (max-width: ${theme.grid.resolution.tablet.width}px) {
    .reg-button {
      margin-top: ${theme.grid.spacing.s}px;
    }
  }

  @media (min-width: ${theme.grid.resolution.tablet.width}px) {
    .enter-reg-wrapper {
      flex-direction: row;
      align-items: baseline;
    }
    .reg-button {
      margin-left: ${theme.grid.spacing.s}px;
    }
    .button-tooltip-container {
      position: relative;
      bottom: 3px;
    }
    .reg-input {
      width: 157px;
      .input-wrapper {
        width: 157px;
      }
    }
  }
`
